// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import InternalInput from '../input/internal';
import styles from './styles.css.js';
const ButtonDropdownFilter = React.forwardRef((props, ref) => {
    return (React.createElement("div", { className: styles.filter },
        React.createElement(InternalInput, { ref: ref, type: "visualSearch", autoComplete: false, disableBrowserAutocorrect: true, invalid: false, __noBorderRadius: true, ...props, nativeInputAttributes: {
                'aria-expanded': true,
                'aria-haspopup': true,
                role: 'combobox',
                autoCorrect: 'off',
                autoCapitalize: 'off',
                ...props.nativeInputAttributes,
            }, __skipNativeAttributesWarnings: true })));
});
export default ButtonDropdownFilter;
//# sourceMappingURL=filter.js.map